export default "__VITE_ASSET__b47e27eb__"